import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const DEFAULT_USER = {
  uid: 'u_tradeadhya_pro',
  email: 'trader@tradeadhya.in',
  name: 'TradeAdhya Trader',
  subscriptionPlan: 'PRO TRIAL',
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem('TradeAdhya-user');
      if (storedUser) return JSON.parse(storedUser);
    } catch (e) {
      console.error('Error loading stored user', e);
    }
    return DEFAULT_USER;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('TradeAdhya-user');
      if (!storedUser) {
        localStorage.setItem('TradeAdhya-user', JSON.stringify(DEFAULT_USER));
      }
    } catch (e) {}
  }, []);

  // TODO: Replace these with Firebase Auth later
  const login = async (email, password) => {
    setLoading(true);
    const displayName = email ? email.split('@')[0] : 'Trader';
    const mockUser = { uid: 'u_' + Date.now(), email, name: displayName };
    localStorage.setItem('TradeAdhya-user', JSON.stringify(mockUser));
    setUser(mockUser);
    setLoading(false);
    return mockUser;
  };

  const signup = async (email, password, name) => {
    setLoading(true);
    // Mock signup
    const mockUser = { uid: '123', email, name };
    localStorage.setItem('TradeAdhya-user', JSON.stringify(mockUser));
    setUser(mockUser);
    setLoading(false);
  };

  const loginWithGoogle = async () => {
    setLoading(true);
    // Mock google login
    const mockUser = { uid: '123', email: 'google@user.com', name: 'Google User' };
    localStorage.setItem('TradeAdhya-user', JSON.stringify(mockUser));
    setUser(mockUser);
    setLoading(false);
  };

  const logout = async () => {
    setLoading(true);
    localStorage.removeItem('TradeAdhya-user');
    setUser(null);
    setLoading(false);
  };

  const resetPassword = async (email) => {
    // Mock reset password
    console.log(`Password reset link sent to ${email}`);
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider 
      value={{ 
        user, 
        loading, 
        isAuthenticated, 
        login, 
        signup, 
        loginWithGoogle, 
        logout, 
        resetPassword 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
